import {Select} from '@mantine/core';

import {BillingChannel} from '../types.ts';
import {useReconciliationReportsChannel} from '../hooks/useReconciliationReports.ts';

// FNP-535: listReconciliationReports REQUIRES a channel (the channel-runStartedAt-index
// partition key), so the list is always scoped to one channel. This selector drives the
// module-scoped channel store (default STRIPE); changing it re-runs the infinite query.
const CHANNEL_OPTIONS: { value: BillingChannel, label: string }[] = [
    {value: 'STRIPE', label: 'Stripe'},
    {value: 'AWS_MARKETPLACE', label: 'AWS Marketplace'},
    {value: 'INTERNAL', label: 'Internal'},
];

export const ChannelSelector = () => {
    const {channel, handleSetChannel} = useReconciliationReportsChannel();

    return (
        <Select
            aria-label='Channel'
            data={CHANNEL_OPTIONS}
            value={channel}
            onChange={(value) => {
                if (value) {
                    handleSetChannel(value as BillingChannel);
                }
            }}
            allowDeselect={false}
            w={180}
        />
    );
};
